// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1531":"301054aa","3553":"3159251e","6655":"301054aa"}[chunkId] + ".chunk.css";
};